const {UserPermissionsContext} = require('context/UserPermissions')
const {useContext} = require('react')

const useUserPermissions = () => {
  const context = useContext(UserPermissionsContext)

  if (!context) {
    throw new Error('useUserPermissions must be used within a UserPermissionsProvider')
  }

  return context
}

export default useUserPermissions
